import { render, staticRenderFns } from "./HeadCom.vue?vue&type=template&id=b245abd2&"
import script from "./HeadCom.vue?vue&type=script&lang=js&"
export * from "./HeadCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports